function headingsToLabels(t) {
  const e = t.querySelectorAll("h2");
  if (void 0 !== e[0]) {
    const r = e[0].innerText;
    t.setAttribute("aria-label", r),
    t.querySelector("a.article--excerpt-image") &&
    t.querySelector("a.article--excerpt-image").setAttribute("title", r),
    t.querySelector("a.productitem--image-link") &&
    t.querySelector("a.productitem--image-link").setAttribute("title", r);
  }
}
window.onload = function () {
	var t = undefined;
	function e(t, e, r) {
		t.setAttribute(e, r);
	}
	document.querySelector("footer.site-footer").removeAttribute("role"), i();
	const r = document.querySelectorAll(
		".message-banner--container, .atc-banner--container"
	);
	function c(t) {
		t.forEach(function (t) {
			t.getAttribute("title") ||
				t.setAttribute("title", "third party application iframe");
		});
	}
	function i() {
		var t = document.querySelectorAll("iframe");
		setTimeout(function () {
			c((t = document.querySelectorAll("iframe")));
		}, 5e3);
	}
	r &&
		r.forEach(function (t) {
			e(t, "aria-atomic", "true");
		});
	const o = document.querySelector("body");
	if (o.classList.contains("template-index")) {
		const t = document.querySelectorAll("a.logolist--link");
		t &&
			t.forEach(function (t) {
				var e = t.querySelectorAll("img");
				if (!e[0].getAttribute("alt")) {
					e[0].setAttribute("alt", "brand logo");
				}
				e &&
					e[0].getAttribute("alt") &&
					t.setAttribute("title", e[0].getAttribute("alt"));
			});



    //remove aria "roles" pertaining to grid and group b/c they're not being used properly
    function covetRemoveRoles() {
      var covetThing = document.querySelector('.covet-pics-gallery covet-pics-widget').shadowRoot;
      if(covetThing) {
        var galleryGrid = covetThing.querySelector('.gallery.grid');
        if(galleryGrid) {
          galleryGrid.removeAttribute('role');
        }
      var gridItems = covetThing.querySelectorAll('.grid-item');
        if (gridItems.length > 0) {
          gridItems.forEach(function (gridItem) {
            gridItem.removeAttribute('role');
          });
          thingDone = true;
        }
      }
    }

    const e = document.querySelector("div.covet-pics-wrap");
    if (e) {
      const t = undefined;
      e.parentElement.setAttribute("aria-label", "Instagram Feed");
      var thingDone = false,
      num = 0;
      //repeat every 1/2 second until done (becuase it's not in dom on window.load), but don't go on forever if 5 seconds have passed.
      const interval = setInterval(function () {
        covetRemoveRoles();
        num++;
        //console.log(num);
        if (thingDone || num > 10) {
          clearInterval(interval);
        }
      }, 500);
    }
	}
	if (o.classList.contains("template-cart")) {
		const t = document.getElementById("gift-wrapping");
		const e = document.querySelectorAll('[data-cartitem-id="168914572"]');
		if (e[0]) {
			const r = undefined;
			e[0]
				.querySelector(".cart-item--remove-link")
				.addEventListener("click", function () {
					t.click();
				});
		}
	}
	if (o.classList.contains("template-product")) {
		const t = document.querySelector("section.product--container");
		const r = document.querySelector("article.product--outer");
		const c = document.querySelector("h1.product-title");
		t && c && e(t, "aria-label", c.innerText),
			r && c && e(r, "aria-label", c.innerText);
	}
	const n = document.querySelectorAll("section");
	n &&
		n.forEach(function (t) {
			headingsToLabels(t);
		});
	const a = document.querySelectorAll("article");
	a &&
		a.forEach(function (t) {
			headingsToLabels(t);
		});
	const l = [];
	function u(t, e) {
		l.includes(t.getAttribute("aria-label")) &&
			(e++,
			t.setAttribute("aria-label", t.getAttribute("aria-label") + " " + e)),
			t.getAttribute("aria-label") && l.push(t.getAttribute("aria-label"));
	}
	let s = 1;
	n.forEach(function (t) {
		u(t, s);
	});
	let d = 1;
	a.forEach(function (t) {
		u(t, d);
	});
	const m = document.querySelectorAll(".page-content table");
	m &&
		m.forEach(function (t) {
			t.removeAttribute("width");
		});
};
//# sourceMappingURL=/s/files/1/0017/7502/t/111/assets/accessibility_fixes.js.map?v=1639682810

const productGridItems = document.querySelectorAll(".productgrid--item");
if (productGridItems) {
	productGridItems.forEach(function (item) {
      //console.log(item);
		item.removeAttribute("aria-hidden");
	});
}

const productItemActionTriggers = document.querySelectorAll(
	".productitem--action-trigger"
);
if (productItemActionTriggers) {
	productItemActionTriggers.forEach(function (item) {
		item.removeAttribute("aria-hidden");
	});
} 
const articleExcerpts = document.querySelectorAll(".article--excerpt-wrapper");
if (articleExcerpts) {
	articleExcerpts.forEach(function (item) {
      //console.log(item.querySelector('a.article--excerpt-image'))
      if(item.querySelector('a.article--excerpt-image')) {
       // console.log(item)
         var articleTitle = item.querySelector('h2').textContent;
        item.querySelector('a.article--excerpt-image').setAttribute('title', articleTitle)
      } else {
        //console.log('no')
      }
       
  	  item.removeAttribute("aria-hidden");
	});
}
